import React from 'react';
import './WebcamCapture.css';

function QrPlaceholderIcon() {
  return (
    <span className="placeholder-qr-icon" aria-hidden="true">
      <span className="placeholder-qr-corner placeholder-qr-corner-tl" />
      <span className="placeholder-qr-corner placeholder-qr-corner-tr" />
      <span className="placeholder-qr-corner placeholder-qr-corner-bl" />
    </span>
  );
}

interface PlaceholderVisualProps {
  mode: string;
}

function PlaceholderVisual({ mode }: PlaceholderVisualProps) {
  if (mode === 'qr') {
    return <QrPlaceholderIcon />;
  }

  if (mode === 'hybrid') {
    return (
      <span className="placeholder-mode-hybrid" aria-label="Text and QR scanner">
        <span className="placeholder-text-chip">a..z</span>
        <span className="placeholder-mode-separator" aria-hidden="true">
          |
        </span>
        <QrPlaceholderIcon />
      </span>
    );
  }

  return <span className="placeholder-text-chip">a..z</span>;
}

interface WebcamPlaceholderProps {
  onActivate: () => void;
  mode?: string;
  placeholderChar?: string;
}

function WebcamPlaceholder({ onActivate, mode = 'barcode', placeholderChar }: WebcamPlaceholderProps) {
  return (
    <div className="video-placeholder" onClick={onActivate}>
      {placeholderChar ? <span className="placeholder-text">{placeholderChar}</span> : <PlaceholderVisual mode={mode} />}
    </div>
  );
}

export { QrPlaceholderIcon };
export default WebcamPlaceholder;
